import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { calcApi, getActiveCalc, setActiveCalc } from "@/lib/customCalc";
import { useBuilderLang } from "@/lib/builderStrings";

// Calculator picker shown at the top of Daily Entry. Odisha stays the default.
export default function CalcSwitcher({ value, onChange }) {
  const { b } = useBuilderLang();
  const [list, setList] = useState([]);
  useEffect(() => {
    calcApi.list().then((l) => {
      const pub = l.filter((c) => c.status === "published");
      setList(pub);
      const cur = getActiveCalc();
      if (!pub.some((c) => c.id === cur)) { setActiveCalc("odisha"); onChange(pub[0]); }
    }).catch(() => setList([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (list.length < 2) {
    return (
      <Link to="/app/calculators" className="text-xs font-semibold text-thali-green inline-flex items-center gap-1" data-testid="calc-switch-build">
        <Settings2 className="w-3.5 h-3.5" /> {b("new_calc")} →
      </Link>
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid="calc-switcher">
      <select className="input-thali flex-1 font-semibold" value={value}
        onChange={(e) => { setActiveCalc(e.target.value); onChange(list.find((c) => c.id === e.target.value)); }} data-testid="calc-switch-select">
        {list.map((c) => <option key={c.id} value={c.id}>{c.locked ? "🔒 " : "🛠️ "}{c.name}</option>)}
      </select>
      <Link to="/app/calculators" className="btn-ghost px-3" aria-label={b("my_calcs")} data-testid="calc-switch-manage"><Settings2 className="w-4 h-4" /></Link>
    </div>
  );
}
